import { useEffect, useMemo, useState } from "react";
import useAPI from "./useAPI";

const safeStringify = (value) => {
  try {
    return JSON.stringify(value || {}, null, 2);
  } catch (error) {
    return "{}";
  }
};

export default function useAdminForm(props) {
  const { currentItem, callback, onSave } = props;

  const [formName, setFormName] = useState(currentItem?.name || "");
  const [contentAsText, setContentAsText] = useState(
    safeStringify(currentItem?.content || {})
  );
  const [submitting, setSubmitting] = useState(false);

  const { query: updateForm } = useAPI({
    defer: true,
    type: "put",
    url: `forms/${currentItem?.id || "0"}`,
    body: {
      formName,
      formContent: {},
    },
  });

  useEffect(() => {
    setFormName(currentItem?.name || "");
    setContentAsText(safeStringify(currentItem?.content || {}));
  }, [currentItem]);

  const parsedContent = useMemo(() => {
    try {
      return JSON.parse(contentAsText || "{}");
    } catch (error) {
      return null;
    }
  }, [contentAsText]);

  const parseError = useMemo(() => {
    try {
      JSON.parse(contentAsText || "{}");
      return "";
    } catch (error) {
      return error.message || "Erreur de parsing";
    }
  }, [contentAsText]);

  const handleSave = async () => {
    if (!currentItem?.id) {
      onSave?.({ success: false, message: "Aucun formulaire selectionne" });
      return;
    }

    if (parseError) {
      onSave?.({ success: false, message: "JSON invalide" });
      return;
    }

    setSubmitting(true);
    try {
      await updateForm({
        url: `forms/${currentItem.id}`,
        body: {
          formName,
          formContent: parsedContent || {},
        },
      });
      onSave?.({ success: true, message: "Formulaire mis a jour" });
      callback?.();
    } catch (error) {
      onSave?.({ success: false, message: "Erreur de mise a jour du formulaire" });
    } finally {
      setSubmitting(false);
    }
  };

  return {
    id: currentItem?.id || "",
    formName,
    contentAsText,
    submitting,
    parseError,
    onFormNameChange: (e) => setFormName(e.target.value),
    onContentChange: (e) => setContentAsText(e.target.value),
    handleSave,
  };
}
